import type { Metadata } from "@/lib/head";
import type { ReactNode } from "react";

import { BRAND_NAME } from "@buildpy/ui/brand-paths";

// 고객 화면(/s·/c)은 시공사 브랜드 — 루트의 「· 빌드파이」 제목 템플릿·applicationName·description·파일 메타데이터(파비콘·OG·twitter 이미지·매니페스트) 상속을 끊는다.
export const CUSTOMER_METADATA: Metadata = {
  title: { template: "%s", absolute: BRAND_NAME },
  description: null,
  openGraph: null,
  twitter: null,
  icons: [],
  manifest: null,
  applicationName: null,
};

// 2단계 고객 레이아웃 전용 — /s·/c 레이아웃 default 를 재사용하면 그쪽에 래퍼가 생길 때 이중으로 감싸진다.
export const CustomerPassthroughLayout = ({ children }: { children: ReactNode }) => children;
